var CaseWorldView = require('../Views/CaseWorldView');
var utils = require('util');
var CompositeElementView = require('../Views/CompositionElementView');
var PartView = require('../Views/PartView');
var PartCache = require('../Models/PartCache');
var BuilderApi = require('../Models/BuilderApi');
var EventEmitter = require('events').EventEmitter;

var memory = 0;

var CaseWorldController = module.exports = function(config){
    var {data, basePath} = config;
    this.caseJson = data.visualizerData;
    this.cache = new PartCache(basePath);
    this.caseWorldView = new CaseWorldView(this.caseJson);

    this.zoomOngoing = false;

    this.setMaxListeners(0);

};

utils.inherits(CaseWorldController, EventEmitter);

CaseWorldController.prototype.load = function($inElement){
    var that = this;

    that._createViews();

    //this.caseWorldView.preloadParts(that.possibleParts);

    this.caseWorldView.createWorld($inElement);

    this.caseWorldView.once('WorldCreated', function() {
        that.caseWorldView.render();

        // we do responsive stying in css. three js sets its own sizes, so unset them here...
        $inElement.find('canvas').css({height:'', width: ''});

        if(!Detector.webgl) {
            that.caseWorldView.interactionHandler.updateCameraCenter();
            that.moveCameraTo('front');
        }

                //THREEx.Screenshot.bindKey(that.caseWorldView.renderer, {charCode: 32});
    });

    that.caseWorldView.once('renderingInitialized', function() {
        that.caseWorldView.interactionHandler.once('fullCameraRotationDone', function() {
            that.endAction();
        });

    });
};

CaseWorldController.prototype.scaleCaseHeightTo = function(newHeight) {
    var that = this;
    var caseWorldModel = that.caseWorldView.getModel();
    var oldHeight = caseWorldModel._height;
    that.startAction();

    var change = newHeight - oldHeight;
    var globalScale = that.caseWorldView.updateHeight(newHeight);

    if(globalScale){
        that.caseWorldView.scaleHeight(globalScale, change);
    }else {
        that.caseWorldView.scaleHeight(newHeight/oldHeight, change);
    }

    if(that.caseWorldView.interactionHandler) {
        that.caseWorldView.interactionHandler.positionCamera();
    }
};

CaseWorldController.prototype.scaleCaseLengthTo = function(newLength) {
    var that = this;

    var oldLength = that.caseWorldView.getModel()._length;
    that.startAction();
    that.caseWorldView.updateLength(newLength);

    that.caseWorldView.scaleLength((newLength/oldLength), newLength - oldLength);

    if(that.caseWorldView.interactionHandler) {
        that.caseWorldView.interactionHandler.positionCamera();
    }

};

CaseWorldController.prototype.scaleCaseDepthTo = function(newDepth){
    var that = this;
    var oldDepth = that.caseWorldView.getModel()._depth;

    var change = newDepth - oldDepth;
    that.startAction();

    that.caseWorldView.updateDepth(newDepth);

    that.caseWorldView.scaleDepth(newDepth/oldDepth, change);


    if(that.caseWorldView.interactionHandler) {
        that.caseWorldView.interactionHandler.positionCamera();
    }

};

CaseWorldController.prototype._createViews = function() {
    var that = this;

    Object.keys(that.caseJson).forEach(function(attribute) {
        var type = '';
        var attributeData = that.caseJson[attribute];
        if($.isPlainObject(attributeData) && 'partType' in attributeData) {
            type = attributeData['partType'];
        }else if(Array.isArray(attributeData) && attributeData.length > 0 && 'partType' in attributeData[0]) {
            type = attributeData[0]['partType'];
        }

        if(type == 'PART') {
            if(Array.isArray(attributeData)) {
                attributeData.forEach(function(part){
                    that.caseWorldView.addElementView(new PartView(part, that.caseJson._height, that.caseJson._length, that.caseJson._depth));
                });
            }else {
                that.caseWorldView.addElementView(new PartView(attributeData, that.caseJson._height, that.caseJson._length, that.caseJson._depth));
            }

        }else if(type == 'COMPOSITION_PART') {
            that.caseWorldView.addElementView(new CompositeElementView(attributeData, attributeData.numberOfParts, that.caseWorldView.getLoadedModelsCache()), attribute);
        }
    });


};

CaseWorldController.prototype.addRollsOrFeeds = function(configuredCaseId, partId, category, file, textureFile, normalMaps) {

    var that = this;

    that.caseWorldView.activateRolls(category);

};

CaseWorldController.prototype.removeRollsOrFeeds = function() {
    var that = this;
    that.caseWorldView.activateRolls(false);
};

CaseWorldController.prototype.activateOption = function(configuredCaseId, option) {
};

CaseWorldController.prototype.deactivateOption = function(configuredCaseId, option) {

};

CaseWorldController.prototype.changeElement = function(configuredCaseId, partId, category, file, textureFile, normalMaps,  on, needUpdate, invisiblePart) {
    var that = this;

    that.caseWorldView.changeElement(partId, category, file, textureFile, normalMaps, on);
};

CaseWorldController.prototype.getCaseWorldView = function() {
    return this.caseWorldView;
};

CaseWorldController.prototype.moveCameraTo = function(position) {
    var that = this;

    var camera = that.caseWorldView.getCamera();
    var newPosition = new THREE.Vector3();
    var offset = 0;
    var model = that.caseWorldView.getModel();
    var interactionHandler = that.caseWorldView.interactionHandler;
    var yPosition = interactionHandler.cameraControl.center.y;
    var scalar = 6;

    that.startAction();
    if(position === 'front') {
        newPosition.set(0, yPosition, scalar * (model._depth/2) );
    }else if(position === 'right') {
        newPosition.set(scalar*(model._length/2), yPosition, 0);
    }else if(position === 'back') {
        newPosition.set(0, yPosition, -scalar*(model._depth/2));
    }else if(position === 'left') {
        newPosition.set(-scalar*(model._length/2), yPosition, 0);
    }else if(position === 'top') {
        var height = scalar * parseInt(model._height);

        newPosition.set(0, height , -0.001);
    }else {
        var cameraCoordinates = position.split('x');
        newPosition = new THREE.Vector3(parseInt(cameraCoordinates[0]), parseInt(cameraCoordinates[1]), parseInt(cameraCoordinates[2]));
    }

    interactionHandler.moveCameraTo(camera.position, newPosition);

    interactionHandler.once('cameraAnimationDone', function() {
        interactionHandler.once('cameraAnimationDone', function() {
            that.endAction();
            that.emit('cameraAnimationDone');

        });

        interactionHandler.positionCamera();
    });

};

CaseWorldController.prototype.zoom = function(mode) {
    var that = this;

    if(!that.zoomOngoing) {
        var interactionHandler = that.caseWorldView.interactionHandler;

        var scalar = 1;
        var zoomFactor = 0.90;
        that.startAction();
        that.zoomOngoing = true;
        if(mode === 'zoom_in') {
            scalar = zoomFactor;
        }else if(mode === 'zoom_out') {
            scalar = 1/zoomFactor;
        }

        //that.caseWorldView.getCamera().position.multiplyScalar(scalar);

        var cameraPosition = that.caseWorldView.getCamera().position;
        var newPosition = cameraPosition.clone().multiplyScalar(scalar);
        interactionHandler.once('cameraAnimationDone', function() {
            that.endAction();
            setTimeout(function() {
                that.zoomOngoing = false;
            }, 100);
        });


        interactionHandler.moveCameraTo(cameraPosition, newPosition, false, 200);
    }

};

CaseWorldController.prototype.prepareForUpdate = function() {
    var that = this;
    this.startAction();

    this.caseWorldView.once('WorldCreated', function() {
        that.caseWorldView.updateStage();

        that.caseWorldView.clearOldElementViews();
    });
}

CaseWorldController.prototype.updateKeyboard = function() {
    var that = this;
    that.once('caseUpdated', function() {
        that.caseWorldView.interactionHandler.positionCamera(400);
    });
};

CaseWorldController.prototype.isStartAnimationActive = function() {
    return !this.caseWorldView.startAnimationDone;
};

CaseWorldController.prototype.startAction = function() {
    this.getCaseWorldView().emit('beginRendering');
};

CaseWorldController.prototype.endAction = function() {
    this.getCaseWorldView().emit('cancelRendering');
};

CaseWorldController.prototype.performUpdate = function(data) {
    var that = this;
    this.caseJson = data.visualizerData;
    this.caseWorldView.setModel(this.caseJson);

    this.caseWorldView.bufferElementViews();

    this._createViews();

    this.caseWorldView.initCaseElements(true);
    this.caseWorldView.once('WorldCreated', function () {
        that.caseWorldView.clearOldElementViews();
        that.endAction();
    });
}



// WEBPACK FOOTER //
// ./node_modules/@thomann/caseconfigurator/lib/Controllers/CaseWorldController2.js